module.exports = __webpack_public_path__ + "img/slide-1.12e31db0.jpg";